import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const WoodmenLifeLearningCenterIcon: React.FC<WLIconProps> = ({
  variant,
  ...rest
}) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescWLLearningCenter">person at a computer</desc>

      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M49.4 117.5h27.8v3.6h-5.7v3.7h9.2v-1a11.5 11.5 0 0 1 4.6-9.1 23.1 23.1 0 0 1 2.2-7H51.2V67.2H100a20.4 20.4 0 0 1 2.4-3.7h-53a1.9 1.9 0 0 0-1.9 1.8v50.3a1.9 1.9 0 0 0 1.9 1.9Zm31.3 10.7H50.8a1.9 1.9 0 0 0 0 3.7h30Zm37.6-35a16.8 16.8 0 1 0-16.8-16.8 16.8 16.8 0 0 0 16.8 16.8Zm29.4 23.2a19.7 19.7 0 0 0-19.6-18.2h-19.6a19.7 19.7 0 0 0-19.6 18.2 8.2 8.2 0 0 0-4.8 7.4v15.3s0 2.3 2 2.3 1.7-2.3 1.7-2.3v-15.3a4.4 4.4 0 0 1 4.5-4.4h52a4.5 4.5 0 0 1 4.5 4.4v15.3s-.3 2.6 2 2.6 1.7-2.6 1.7-2.6v-15.3a8.2 8.2 0 0 0-4.8-7.4Z"
        className="accent"
      />
      <rect
        x="57.5"
        y="74.4"
        width="37.5"
        height="4.9"
        rx="1.6"
        className="accent"
      />
      <rect
        x="57.5"
        y="84.6"
        width="37.5"
        height="4.9"
        rx="1.6"
        className="accent"
      />
      <rect
        x="57.5"
        y="94.7"
        width="31.1"
        height="4.9"
        rx="1.4"
        className="accent"
      />
    </Icon>
  );
};

export default WoodmenLifeLearningCenterIcon;
